<template lang="pug">
  #RepuestosRecibidosBodega
    b-button(
      variant="action"
      @click="openModal"
    )
      | Repuestos Recibidos Bodega
    //- Modal para confirmar rechazo
    b-modal.hide-footer(v-model="showModal" no-close-on-backdrop, title="Recibir repuestos en bodega")
      h7 ¿Estás seguro de recibir los repuestos en bodega?
      table.table.table-border.table-hover.mt-4
        thead
          tr
            th N° Parte
            th Descripción
        tbody
          tr(v-for="(repuesto, index) in repuestosParaRecibir" :key="index")
            td {{ repuesto.parte.part_number }}
            td {{ repuesto.parte.description  }}

      template(#modal-footer='{ ok, cancel, hide }')
        b-button(size='sm' variant='secondary' @click='hideModal' :disabled="loading") No
          b-spinner(v-if="loading" small)
        b-button(size='sm' variant='primary' @click='recibirBodega' :disabled="loading") Si
          b-spinner(v-if="loading" small)
  </template>
<script>
  import { mapActions } from 'vuex'
  import moment from 'moment'
  import print from '@/utils/print'

  export default {
    name: 'RechazarCotizacion',
    data() {
      return {
        showModal: false,
        loading: false,
      }
    },
    props: {
      dataOv: {
        type: Object,
        required: true,
      },

    },
    methods: {
      ...mapActions('OVStore', ['receivePartsStore']),
      printOVParts() {
        const oportunidadVenta = this.dataOv
        oportunidadVenta.rma = this.rma
        oportunidadVenta.vendedor = `${this.user.first_name} ${this.user.last_name}`
        const repuestosForm =  this.repuestosParaRecibir.map((repuesto) => ({
          id: repuesto.parte.id,
          nSerie: repuesto.parte.part_number,
          disponible: true,
        }))
        print(
          this.dataOv.id,
          repuestosForm,
          oportunidadVenta,
          moment().format('DD/MM/YYYY H:mm:ss'),
          'OV'
        )
      },
      async recibirBodega() {
        this.loading = true
        await this.receivePartsStore({ id_oportunidad_venta: this.dataOv?.id })
        this.$emit('reloadAll')
        this.loading = false
        this.hideModal()
      },
      openModal() {
        this.showModal = true
      },
      hideModal() {
        this.showModal = false
      },
    },
    computed: {
     repuestosParaRecibir(){
       return this.dataOv?.detalle_venta.filter(repuesto => !repuesto.repuesto_disponiblidad)
     }
    },
  }
  </script>
  <style lang="scss" scoped>
  .center {
    text-align: center;
    width: 100%;
  }
  table.table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 0.9em;
  font-family: 'Roboto', sans-serif;

  thead {
    background-color: #343a40;
    color: #ffffff;
    text-align: center;
  }

  th, td {
    padding: 12px 15px;
    border: 1px solid #dee2e6;
  }

  tbody {
    tr {
      &:nth-child(even) {
        background-color: #f8f9fa;
      }
      &:hover {
        background-color: #e9ecef;
      }
    }
  }
}
  </style>
